export default __webpack_public_path__ + "static/media/antler.1d2751f8.png";